import { render, staticRenderFns } from "./InSwitchLED65Mecha.vue?vue&type=template&id=f157b1c6&scoped=true&"
import script from "./InSwitchLED65Mecha.vue?vue&type=script&lang=js&"
export * from "./InSwitchLED65Mecha.vue?vue&type=script&lang=js&"
import style0 from "./InSwitchLED65Mecha.vue?vue&type=style&index=0&id=f157b1c6&lang=scss&scoped=true&"
import style1 from "./InSwitchLED65Mecha.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f157b1c6",
  null
  
)

export default component.exports